import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { SKIPPED, computeStackTrace, objectEntries, addTelemetryError } from '@datadog/browser-core';
export function startSourceCodeContext(hooks) {
  var browserWindow = window;
  var contextByFile = new Map();
  function buildContextByFile() {
    if (!browserWindow.DD_SOURCE_CODE_CONTEXT) {
      return;
    }
    objectEntries(browserWindow.DD_SOURCE_CODE_CONTEXT).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        stack = _ref2[0],
        context = _ref2[1];
      var stackTrace = computeStackTrace({
        stack: stack
      });
      var firstFrame = stackTrace.stack[0];
      if (!firstFrame.url) {
        addTelemetryError('Source code context: missing frame url', {
          stack: stack
        });
        return;
      }
      // don't overwrite existing context
      if (!contextByFile.has(firstFrame.url)) {
        contextByFile.set(firstFrame.url, context);
      }
    });
    browserWindow.DD_SOURCE_CODE_CONTEXT = {};
  }
  buildContextByFile();
  hooks.register(0 /* HookNames.Assemble */, function (_ref3) {
    var domainContext = _ref3.domainContext,
      rawRumEvent = _ref3.rawRumEvent;
    buildContextByFile();
    if (contextByFile.size === 0) {
      return SKIPPED;
    }
    var url = getSourceUrl(domainContext, rawRumEvent);
    var context = url && contextByFile.get(url);
    if (!context) {
      return SKIPPED;
    }
    return {
      type: rawRumEvent.type,
      service: context.service,
      version: context.version
    };
  });
}
function getSourceUrl(domainContext, rawRumEvent) {
  var _a, _b;
  if (rawRumEvent.type === 'long_task' && rawRumEvent.long_task.entry_type === 'long-animation-frame') {
    return (_a = rawRumEvent.long_task.scripts[0]) === null || _a === void 0 ? void 0 : _a.source_url;
  }
  var stack;
  if ('handlingStack' in domainContext) {
    stack = domainContext.handlingStack;
  }
  if (rawRumEvent.type === 'error' && rawRumEvent.error.stack) {
    stack = rawRumEvent.error.stack;
  }
  var stackTrace = computeStackTrace({
    stack: stack
  });
  return (_b = stackTrace.stack[0]) === null || _b === void 0 ? void 0 : _b.url;
}